import styles from '../../../MultiStepPMSLogin.module.scss'
import interfaceIdAndKey from './interfaceIdAndKey.png'
import loginScreen from './loginScreen.png'
import registerNew from './registerNew.png'
import urlLogin from './urlLogin.png'

const InterfaceIdAndKey = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionText}>
        If you are already logged in to Opera Cloud, sign out using the menu on the top
        right.
      </p>
      <img src={loginScreen} alt="" />
      <p className={styles.descriptionText}>
        Click on <span className={styles.descriptionTextEmp}>Register New Account</span> .
      </p>
      <p className={styles.descriptionText}>
        Now you should be seeing a sign up page. Add{' '}
        <span className={styles.descriptionTextEmp}>&apiuser=y</span> to the end of the
        current URL like this:
      </p>
      <img src={urlLogin} alt="" />
      <p className={styles.descriptionText}>Press enter to go to this URL.</p>
      <p className={styles.descriptionText}>
        Fill in the form as in the screenshot below, then click{' '}
        <span className={styles.descriptionTextEmp}>Register</span>.
      </p>
      <img src={registerNew} alt="" />
      <p className={styles.descriptionText}>
        After registration, Take note of{' '}
        <span className={styles.descriptionTextEmp}>Interface id</span> and{' '}
        <span className={styles.descriptionTextEmp}>Interface Key</span>.
      </p>
      <img src={interfaceIdAndKey} alt="" />
    </div>
  )
}

export default InterfaceIdAndKey
